import { LineElement, RectangleElement, CircleElement } from '@/types'

interface ShapeElementPreviewProps {
  element: LineElement | RectangleElement | CircleElement
  zoom: number
  mmToPx: number
  ignoreRotation?: boolean // If true, rotation is handled by parent via CSS
}

export function ShapeElementPreview({ element, zoom, mmToPx, ignoreRotation = false }: ShapeElementPreviewProps) {
  const color = element.color === 'B' ? 'black' : 'white'

  if (element.type === 'line') {
    // For lines, we need to handle rotation ourselves since CSS rotation
    // on the parent container causes visual issues with positioning
    const isRotated90 = !ignoreRotation && (element.rotation === 'R' || element.rotation === 'B')

    // Swap dimensions for 90/270 degree rotation
    const displayWidth = isRotated90 ? element.height : element.width
    const displayHeight = isRotated90 ? element.width : element.height

    const width = displayWidth * mmToPx * zoom
    const height = displayHeight * mmToPx * zoom

    return (
      <div
        style={{
          width,
          height: Math.max(height, 1),
          backgroundColor: color,
        }}
      />
    )
  }

  if (element.type === 'rectangle') {
    const width = element.width * mmToPx * zoom
    const height = element.height * mmToPx * zoom
    const borderWidth = element.borderThickness * zoom * 0.3

    return (
      <div
        style={{
          width,
          height,
          backgroundColor: element.filled ? color : 'transparent',
          border: `${borderWidth}px solid ${color}`,
          boxSizing: 'border-box',
        }}
      />
    )
  }

  if (element.type === 'circle') {
    const diameter = element.diameter * mmToPx * zoom
    const borderWidth = element.borderThickness * zoom * 0.3

    return (
      <div
        style={{
          width: diameter,
          height: diameter,
          borderRadius: '50%',
          backgroundColor: 'transparent',
          border: `${borderWidth}px solid ${color}`,
          boxSizing: 'border-box',
        }}
      />
    )
  }

  return null
}
